import React from "react";
import {observer} from "mobx-react";
import {MerchantPortalDto} from "../../merchant-portal-menu-list-store";
import merchantStoresMenuStore from "../../merchant-portal-menu-list-store";
import FontBody1 from "../../../../../../fonts/font-body1/font-body1";
import Icon from "../../../../../../icons/icon/icon";
import {IconVSign} from "../../../../../../icons/icon-v-sign/icon-v-sign";
import {FONT_COLOR} from "../../../../../../fonts/font-props";
import MerchantPortalMenuItemStore from "../../merchant-portal-menu-item-store";


type OptionProps = {
    portal: MerchantPortalMenuItemStore;
    onSelect: () => void;
}

const Option: React.FC<OptionProps> = observer(({ portal, onSelect }) => {
    const isSelected = merchantStoresMenuStore?.selectedPortal?.id === portal?.id;

    return (
        <div
            className={`portal-selection__option ${isSelected ? 'portal-selection__option--is-selected' : ''} ${portal.isMain ? 'portal-selection__option--is-main' : ''}`}
            onClick={() => onSelect()}
        >
            <FontBody1 color={portal.isMain ? FONT_COLOR.PRIMARY2 : FONT_COLOR.SEMANTIC_3}>{portal.label}</FontBody1>
            {isSelected && <Icon Component={IconVSign}></Icon>}
        </div>
    );
});

export default Option;